function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { startCase } from 'lodash';
import { getAddressForSingleLineDisplay } from './geocode';
import { ADDRESS_TYPES } from '../constants';
function addAdditionalAddressProperties(allAddresses) {
  return Object.keys(allAddresses).reduce(function (acc, curr) {
    var formattedAddresses = allAddresses[curr] ? allAddresses[curr].map(function (addr, index) {
      var _addr$name, _addr$id;
      return _objectSpread(_objectSpread({}, addr), {}, {
        name: (_addr$name = addr.name) !== null && _addr$name !== void 0 ? _addr$name : getAddressForSingleLineDisplay(addr),
        id: (_addr$id = addr.id) !== null && _addr$id !== void 0 ? _addr$id : "".concat(index),
        initial: 'false'
      });
    }) : [];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, formattedAddresses));
  }, {});
}
var sortAddresses = function sortAddresses() {
  var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return addresses === null || addresses === void 0 ? void 0 : addresses.sort(function (a, b) {
    var _b$created_at;
    return Boolean(b.is_primary) - Boolean(a.is_primary) || ((_b$created_at = b.created_at) === null || _b$created_at === void 0 ? void 0 : _b$created_at.localeCompare(a === null || a === void 0 ? void 0 : a.created_at));
  });
};
var getClientAddressName = function getClientAddressName(_ref) {
  var _startCase;
  var name = _ref.name,
    address_type = _ref.address_type,
    is_primary = _ref.is_primary;
  return "".concat((_startCase = startCase(address_type)) !== null && _startCase !== void 0 ? _startCase : 'Unknown').concat(is_primary ? ' (Primary)' : '', ": ").concat(name);
};

// Return addresses grouped by type for display in AddressSelect
var getGroupedAddressOptions = function getGroupedAddressOptions() {
  var clientAddresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var orgAddressOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var options = [];
  if ((clientAddresses === null || clientAddresses === void 0 ? void 0 : clientAddresses.length) > 0) {
    options.push({
      id: ADDRESS_TYPES.CLIENT,
      // AdressSelect valueKey
      name: 'User Address',
      // AdressSelect labelKey
      children: clientAddresses.map(function (addr) {
        return _objectSpread(_objectSpread({}, addr), {}, {
          name: getClientAddressName(addr)
        });
      })
    });
  }
  if ((orgAddressOptions === null || orgAddressOptions === void 0 ? void 0 : orgAddressOptions.length) > 0) {
    options.push({
      id: ADDRESS_TYPES.GROUP,
      name: 'Organization Address',
      children: orgAddressOptions
    });
  }
  if (currentLocation) {
    options.push({
      id: ADDRESS_TYPES.OTHER,
      name: 'Current Location',
      children: [currentLocation]
    });
  }
  return options;
};
var getAddressOptions = function getAddressOptions(initialAddresses, clientData) {
  var _initialAddresses$cli, _processedAllAddresse;
  var addressOptions = _defineProperty(_defineProperty({}, ADDRESS_TYPES.CLIENT, sortAddresses((_initialAddresses$cli = initialAddresses.client) !== null && _initialAddresses$cli !== void 0 ? _initialAddresses$cli : clientData === null || clientData === void 0 ? void 0 : clientData.addresses)), ADDRESS_TYPES.GROUP, [].concat(_toConsumableArray(sortAddresses(initialAddresses.user)), _toConsumableArray(sortAddresses(initialAddresses.ours))));
  var processedAllAddresses = addAdditionalAddressProperties(addressOptions);
  var groupedAddressOptions = getGroupedAddressOptions(processedAllAddresses === null || processedAllAddresses === void 0 ? void 0 : processedAllAddresses.client, processedAllAddresses === null || processedAllAddresses === void 0 ? void 0 : processedAllAddresses.ours, processedAllAddresses === null || processedAllAddresses === void 0 || (_processedAllAddresse = processedAllAddresses.otherAddr) === null || _processedAllAddresse === void 0 ? void 0 : _processedAllAddresse[0]);
  return groupedAddressOptions;
};
export default getAddressOptions;
//# sourceMappingURL=getAddressOptions.js.map